import { AltroImportoLiquidato } from '../../../models/altro-importo-liquidato';
import { CostoGestioneLiquidato } from '../../../models/costo-gestione-liquidato';
import { ImportoLiquidato } from '../../../models/importo-liquidato';
import { Liquidato } from '../../../models/liquidato';

export class SezioneEconomicaLiquidatiAdapter {
  liquidato: Liquidato = new Liquidato();

  constructor(liquidato: Liquidato) {
    this.liquidato.id = liquidato.id;
    this.liquidato.dataLiquidato = liquidato.dataLiquidato;
    this.liquidato.tipoLiquidato = liquidato.tipoLiquidato;
    this.liquidato.note = liquidato.note;
    this.liquidato.importoLiquidato = liquidato.importoLiquidato ? liquidato.importoLiquidato : new ImportoLiquidato();
    if (liquidato.importoLiquidato) {
      this.liquidato.importoLiquidato.importo = liquidato.importoLiquidato.importo;
      this.liquidato.importoLiquidato.interessi = liquidato.importoLiquidato.interessi;
      this.liquidato.importoLiquidato.sanzioni = liquidato.importoLiquidato.sanzioni;
    }
    this.liquidato.costoGestioneLiquidato = liquidato.costoGestioneLiquidato ? liquidato.costoGestioneLiquidato : new CostoGestioneLiquidato();
    if (liquidato.costoGestioneLiquidato) {
      this.liquidato.costoGestioneLiquidato.diritti = liquidato.costoGestioneLiquidato.diritti;
      this.liquidato.costoGestioneLiquidato.compenso = liquidato.costoGestioneLiquidato.compenso;
      this.liquidato.costoGestioneLiquidato.onorari = liquidato.costoGestioneLiquidato.onorari;
      this.liquidato.costoGestioneLiquidato.cpa = liquidato.costoGestioneLiquidato.cpa ?  JSON.parse(JSON.stringify(liquidato.costoGestioneLiquidato.cpa)) : null;
      this.liquidato.costoGestioneLiquidato.iva = liquidato.costoGestioneLiquidato.iva ?  JSON.parse(JSON.stringify(liquidato.costoGestioneLiquidato.iva)) : null;
      this.liquidato.costoGestioneLiquidato.flagRitenutaAcconto = liquidato.costoGestioneLiquidato.flagRitenutaAcconto ? liquidato.costoGestioneLiquidato.flagRitenutaAcconto : false;
      this.liquidato.costoGestioneLiquidato.speseLiquidate = liquidato.costoGestioneLiquidato.speseLiquidate;
      this.liquidato.costoGestioneLiquidato.irap = liquidato.costoGestioneLiquidato.irap;
      this.liquidato.costoGestioneLiquidato.oneriRiflessi = liquidato.costoGestioneLiquidato.oneriRiflessi;
      this.liquidato.costoGestioneLiquidato.speseMarcheNotifica = liquidato.costoGestioneLiquidato.speseMarcheNotifica;
      this.liquidato.costoGestioneLiquidato.art96CPC = liquidato.costoGestioneLiquidato.art96CPC;
      this.liquidato.costoGestioneLiquidato.f23 = liquidato.costoGestioneLiquidato.f23;
      this.liquidato.costoGestioneLiquidato.risarcimento = liquidato.costoGestioneLiquidato.risarcimento;
    } else {
      this.liquidato.costoGestioneLiquidato.cpa = null;
      this.liquidato.costoGestioneLiquidato.iva = null;
      this.liquidato.costoGestioneLiquidato.flagRitenutaAcconto = false;
      this.liquidato.costoGestioneLiquidato.irap = 8.50;
      this.liquidato.costoGestioneLiquidato.oneriRiflessi = 23.08;
    }
    this.liquidato.altroImportoLiquidato = liquidato.altroImportoLiquidato ? liquidato.altroImportoLiquidato : new AltroImportoLiquidato();
    if (liquidato.altroImportoLiquidato) {
      this.liquidato.altroImportoLiquidato.speseRegistrazione = liquidato.altroImportoLiquidato.speseRegistrazione;
      this.liquidato.altroImportoLiquidato.contributoUnificato = liquidato.altroImportoLiquidato.contributoUnificato;
      this.liquidato.altroImportoLiquidato.altroImporto = liquidato.altroImportoLiquidato.altroImporto;
      this.liquidato.altroImportoLiquidato.rimborsoTerzoPignorato = liquidato.altroImportoLiquidato.rimborsoTerzoPignorato;
    }
    this.liquidato.idEsito = liquidato.idEsito ? liquidato.idEsito : null;
  }
}
